"<template>
  <div class="form-group">
    <label>{{ value[defaultLang] }}</label>
    <div v-for="lang in langs" :key="lang" v-if="lang !== defaultLang">
      <el-input v-model="value[lang]" @keyup.enter.native="$emit('save', id)" @keydown.tab.native="$emit('save', id)">
        <template slot="prepend">{{ lang }}</template>
        <template slot="append">
          <el-button @click="$emit('save', id)" class="translation-save">{{$t('settings.actions.save')}}</el-button>
          <font-awesome-icon v-if="loading === true" icon="spinner" spin></font-awesome-icon>
          <font-awesome-icon v-else-if="loading === 'failed'" icon="exclamation-circle" style="color:#C0392B" ></font-awesome-icon>
          <font-awesome-icon  v-else-if="loading === 'success'" icon="check-circle" style="color:#3FC380"></font-awesome-icon>
        </template>
      </el-input>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  props: ['value', 'id', 'loading'],
  data () {
    return {
      strings: {}
    }
  },

  computed: {
    ...mapGetters('account', {
      defaultLang: 'defaultLang'
    }),
    ...mapGetters('account', {
      site: 'currentSite'
    }),

    langs () {
      let langs = []
      this.site.languages.forEach((lang) => {
        langs.push(lang.lang)
      })
      return langs
    }
  },
  mounted () {
    this.strings = Object.assign({}, this.value)
  }
}
</script>

<style lang="scss" scoped>
    .translation-save {
      cursor: pointer;
      &:hover {
        color: #3FC380;
      }
    }
</style>
"



// WEBPACK FOOTER //
// src/components/settings/translations/translations.vue